<template>
  <v-snackbar
    app
    v-model="isActive"
    :color="options.color"
    :top="options.top"
    :left="options.left"
    :right="options.right"
    :bottom="options.bottom"
    :timeout="options.timeout"
    centered
  >
    {{ options.text }}
    <template v-slot:action="{ attrs }">
      <v-btn text icon v-bind="attrs" @click="close_modal()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "wtk-toast",
  data: () => ({}),
  computed: {
    isActive: {
      get() {
        return this.$store.getters["message/toast"].isActive;
      },
      set(val) {
        this.options.isActive = val;
        this.$store.dispatch("message/hide", "toast");
      },
    },
    options() {
      return this.$store.getters["message/toast"].options;
    },
  },
  methods: {
    close_modal() {
      this.$store.dispatch("message/hide", "toast");
    },
  },
};
</script>
